<template>
  <div>
    <h5 class="text-center text-darked px-3 pt-3 m-0">
      {{ skillName }}
    </h5>
    <hr class="my-3" />
    <div v-for="(item, idx) in planAnswers" :key="idx" class="container mt-2">
      <choice
        v-if="
          item.type_question == '1' ||
            (item.type_question == '2' && item.parent_reponses)
        "
        :responses="item.parent_reponses"
        :question="item.text"
        :index="idx + 1"
        :id="item.id"
        class="mb-3"
      />

      <range
        v-if="item.type_question == '3' && item.parent_reponses"
        :responses="item.parent_reponses"
        :question="item.text"
        :index="idx + 1"
        :id="item.id"
        class="mb-3"
      />

      <open-answer
        v-if="item.type_question == '4' && item.parent_reponses"
        :responses="item.parent_reponses"
        :question="item.text"
        :index="idx + 1"
        :id="item.id"
        class="mb-3"
      />

      <fill-table
        v-if="item.type_question == '5' && item.parent_reponses"
        :responses="item.parent_reponses"
        :question="item.text"
        :index="idx + 1"
        :id="item.id"
        class="mb-3"
      />

      <fill-time
        v-if="item.type_question == '6' && item.parent_reponses"
        :responses="item.parent_reponses"
        :question="item.text"
        :index="idx + 1"
        :id="item.id"
        class="mb-3"
      />
    </div>
    <b-button
      @click="goFormPractice"
      variant="outline-primary"
      class="my-3"
      block
    >
      Edit
    </b-button>
  </div>
</template>
<script>
import choice from "@/components/planning/answers/choice.vue";
import range from "@/components/planning/answers/range.vue";
import openAnswer from "@/components/planning/answers/openAnswer.vue";
import fillTable from "@/components/planning/answers/fillTable.vue";
import fillTime from "@/components/planning/answers/fillTime.vue";

export default {
  props: {
    planAnswers: Array,
    Mid: String,
    skillName: String
  },
  components: {
    choice,
    range,
    openAnswer,
    fillTable,
    fillTime
  },
  methods: {
    goFormPractice() {
      this.$parent.state = false;
    }
  }
};
</script>
